<div class="modal-header">
  <h4 class="modal-title mt-0" id="modal-title">{{ isEdit ? ('ADD' | translate) : ('EDIT' | translate) }} {{ 'PARCEL' | translate }}</h4>
  <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12 mb-3">
      <lib-gung-text-input gungTranslate="ID" [(ngModel)]="parcel.id"/>
    </div>

    <!--<div class="col-12 mb-3">
      <lib-gung-text-input gungTranslate="PARENT_GIN_INDENTIFIER" [(ngModel)]="parcel.parentGinIdentifier"/>
    </div>-->

    <div class="col-12 mb-3">
      <lib-gung-text-input gungTranslate="GIN_INDENTIFIER" [(ngModel)]="parcel.ginIdentifier"/>
    </div>

    <div class="col-12 mb-3">
      <lib-gung-text-input gungTranslate="BATCH_NUMBER" [(ngModel)]="parcel.batchNumber"/>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="row w-100">
    <div class="col d-flex justify-content-end">
      <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss()" translate>CANCEL</button>
      <button type="button" class="btn btn-primary btn-sm ml-2" (click)="save()" translate>SAVE</button>
    </div>
  </div>
</div>
